<template>
    <div class="boxprofil">
        
        <div style="float:right;margin:5px;">
            <s-elo :elo="elo" v-if="!club" number="true"/>
        </div>
        <div class="titleBox" v-if="club">
            {{club}}
            <div class="joueur" v-if="club">
                 {{joueur.nom}} {{joueur.prenom}} ({{displayName}})
             </div>
        </div>
        <div class="titleBox" v-if="!club">
            {{displayName}} <br/><span >{{joueur.email}}</span>
            
        </div>
       
        <table class="tableProfil" >
            <tr>
            <th>
                Tournois
            </th>
            <th>
                Parties joués
            </th>
            <th>
                Parties gagnés
            </th>
            </tr>
            <tr>
                <td >
                    {{result.nbTournois}}
                </td>
                <td>
                     {{result.nbParties}}
                </td>
                 <td>
                     {{result.nbGagnes}} 
                     <span v-if="result.nbParties>0" class="percent">({{Math.ceil(result.nbGagnes/result.nbParties*100)}}%)</span>
                </td>
            </tr>
        </table>
        <div style="float:right;margin-right:20px">
            <s-button icon="chart-line" theme="is-primary is-large" label="" @onclick="openStat=true"/>
        </div>
        <statistique 
            :open="openStat"
            :club="club"
            :joueur="joueur"
            @close="openStat=false"
            v-if="joueur"
        />
      </div>
</template>
<style scoped>


     .boxprofil {
        width: 100%;
        text-align: left;
        vertical-align: top;
        height: 270px;
        font-size: 15px;
        padding: 5px;
        border: thin solid var(--bluebg);
        
    }
    .tableProfil {
        width: 100%;
        font-size: 20px;
    }
   .tableProfil tr th {
        width: 33%;
        color: black;
        text-align: center;
        
    }
    .tableProfil tr td {
        width: 33%;
        color: black;
        text-align: center;
       
    }
    .percent {
        font-size: 14px;
    }
    .joues {
        background-color: var(--bluebg);
        color: white;
    }
    .gagnes {
        background-color: #68CC77;
        color: white;
    }
    .nbtournois {
        background-color: #FFD75C;
        color: var(--bluebg);
    }
    
    .joueur {
        font-size: 14px;
        font-weight: bolder;
        color: white;
    }
    .titleBox {
        font-size: 18px;
        font-weight: bolder;
        margin-bottom: 20px;
        background-color: var(--bluebg);
        color: white;
        padding: 14px;
        border-radius: 10px;
    }
   
    .elo {
        float: right;
        border: thin black thin;
        padding : 10px;
        margin-left: 50px;
        font-size: 16px;
        text-align: center;
        color: white;
        border-radius: 20px;
        margin-bottom: 20px;
    }
    .title {
        padding: 10px;
        font-size: 18px;
         color: white;
    }
    .CLASSE_A {
        background-color: rgb(51, 214, 1);
        border-radius: 20px;
    }
    .CLASSE_B {
        background-color: rgb(8, 148, 31);
        border-radius: 20px;
    }
    .CLASSE_C {
        background-color: rgb(141, 107, 6);
        border-radius: 20px;
    }
    .CLASSE_D {
        background-color: rgb(88, 71, 22);
        border-radius: 20px;
    }
    .EXPERT {
        font-weight: bolder;
        background-color: rgb(197, 31, 9);
        color: white;
        border-radius: 20px;
    }
    .ELITE {
        font-weight: bolder;
        background-color: rgb(128, 21, 7);
        color: white;
        border-radius: 20px;
    }
    .MAITRE {
        font-weight: bolder;
        background-color: rgb(2, 2, 2);
        color: white;
        border-radius: 20px;
    }
</style>
<script>
import firebase_api from '@/firebase/firebase_api'
import statistique from '@/views/profil/statistique.vue'
export default {
    props: ['joueur','club'],
    components: {
        statistique
    },
    data() {
        return {
            openStat: false
        }
    },
    mounted() {
        
    },
    computed: {
        displayName: {
            get() {
                if (typeof(this.joueur.displayName)!="undefined")
                    return this.joueur.displayName;
                else 
                    return this.joueur.pseudo;
            }
        },
        elo : {
            get() {
                
               return typeof(this.joueur.elo) == "undefined" ? 1199 : this.joueur.elo
            }
        },    
        result: {
            get() {
                var result = {
                    nbGagnes: 0,
                    nbParties: 0,
                    nbTournois: 0
                }
                return typeof(this.joueur.result) == "undefined" ? result : this.joueur.result
            }
        }
        
    }

}
</script>